import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("waa_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      // Race guard: if the token changed while this request was in flight
      // (e.g. a bypass route logged in a different user), skip the overwrite.
      if (localStorage.getItem("waa_token") === token) {
        setUser(data.user);
      }
    } catch {
      if (localStorage.getItem("waa_token") === token) {
        localStorage.removeItem("waa_token");
        setUser(null);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = (token, userObj) => {
    localStorage.setItem("waa_token", token);
    setUser(userObj);
  };

  const logout = () => {
    localStorage.removeItem("waa_token");
    setUser(null);
  };

  const updateUser = (patch) => setUser((u) => ({ ...u, ...patch }));

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
